export default function moveArrayItemAndReorder<T = {}>(
  array: T[],
  indexFrom: number,
  indexTo: number
) {
  array.splice(indexTo, 0, array.splice(indexFrom, 1)[0]);
}
